import request from '../../utils/request'

// 查询
export function fetchList (data) {
  return request.post('/business/carousel/page', data, {
    trim: true
  })
}

// 导出Excel
export function exportExcel (data) {
  return request.post('/business/carousel/exportExcel', data, {
    trim: true,
    download: true
  })
}

// 创建
export function create (data) {
  return request.post('/business/carousel/create', data)
}

// 修改
export function updateById (data) {
  return request.post('/business/carousel/updateById', data)
}
export function updateStatus (data) {
  return request.post('/business/carousel/updateStatus', data)
}
// 删除
export function deleteById (id) {
  return request.get(`/business/carousel/delete/${id}`)
}

// 批量删除
export function deleteByIdInBatch (ids) {
  return request.get('/business/carousel/delete/batch', {
    params: {
      ids
    }
  })
}

export function getFoodDataVO () {
  return request.get('/business/carousel/getFoodDataVO')
}

// 修改底部访配置
export function updFoodData (data) {
  return request.post('/business/carousel/updFoodData', data)
}
